import React, { Component } from "react";
import { Table, Input, InputNumber, Button, Switch, Divider, message, Icon } from 'antd';
import NHSelect from '../../../common/NHSelect/index';
import { createUuid } from "../../../../utils/NHCore";
import PropTypes from 'prop-types';
import style from '../index.css';

const { TextArea } = Input;

/**
 * 步骤二配置环节信息
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-08 11:18:31
 * Version: 1.0
 * Modify log:
 */
class SeconedStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hjxxData: [] //配置的环节信息数据
        }
        this.cacheData = this.state.hjxxData.map(item => ({ ...item })); //缓存编辑环节信息数据
    }

    componentDidMount() {
        if (this.props.data) {
            this.setState({ hjxxData: this.props.data });
        }
    }

    //编辑环节信息
    edit = (pkid) => {
        const newData = [...this.state.hjxxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            target.editable = true;
            this.setState({ hjxxData: newData });
        }
    }

    //删除环节信息
    delete = (record, pkid) => {

        //删除操作将后续步骤-1
        const newData = this.state.hjxxData.map(item => {
            if (item && (item.bz > record.bz)) {
                item.bz = item.bz - 1;
            }
            return item;
        });

        const target = newData.filter(item => pkid !== item.pkid);
        if (target) {
            this.props.onChange(target);
            this.setState({ hjxxData: target });
            this.cacheData = target.filter(item => item.hjid !== undefined && item.hjid != '')
                .map(item => ({ ...item }));
        }
    }

    //保存编辑的环节信息
    save = (pkid) => {
        const newData = [...this.state.hjxxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            if (target.hjid !== undefined && target.hjid != '') {
                delete target.editable;
                this.props.onChange(newData);
                this.setState({ hjxxData: newData });
                this.cacheData = newData.filter(item => item.hjid !== undefined && item.hjid != '')
                    .map(item => ({ ...item }));
            } else {
                message.error('请选择流程环节！');
            }
        }
    }

    //取消编辑环节信息
    cancel = (record, pkid) => {
        const newData = [...this.state.hjxxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {

            let cache = this.cacheData.filter(item => {
                if (item) {
                    return pkid === item.pkid
                }
            })[0];

            if (cache) {

                //如果是点击取消时，如果缓存数据里有，则获取缓存数据
                Object.assign(target, cache);
                delete target.editable;
                this.setState({ hjxxData: newData });

            } else {

                //如果是点击取消时，缓存数据里没有找到，则删除这条数据
                const afterDelTarget = newData.map(item => {
                    if (item && (item.bz > record.bz)) {
                        item.bz = item.bz - 1;
                    }
                    return item;
                }).filter(item => pkid !== item.pkid);

                if (afterDelTarget) {
                    this.props.onChange(afterDelTarget);
                    this.setState({ hjxxData: afterDelTarget });
                }

            }
        }
    }

    //表格单元格编辑时回调
    handleEditableCellChange = (value, pkid, column) => {
        const newData = [...this.state.hjxxData];

        //报到环节只能设置一个
        if (column == 'sfbdhj') {
            for (let key in newData) {
                newData[key][column] = '0';
            }
        }

        const target = newData.filter(item => pkid === item.pkid)[0];

        if (target) {
            target[column] = value;
            this.setState({ hjxxData: newData });
        }
    }

    //添加环节回调
    handleAddLinkBtnClick = () => {

        const hjxxData = [...this.state.hjxxData];
        let hjxxLength = hjxxData.length;
        if (hjxxLength) {
            if (hjxxLength > 0 && (hjxxData[hjxxLength - 1].hjid == '' || hjxxData[hjxxLength - 1].hjid == null)) {
                message.error('请选择流程环节！');
                return;
            } else {
                this.save(hjxxData[hjxxLength - 1].pkid);
            }
        }

        let newHjxxData = {
            pkid: createUuid(), //数据唯一ID
            bz: hjxxData.length + 1, //步骤
            hjid: '', //环节id
            hjmc: '', //环节名称
            hjlb: '1', //环节类别（是否必须）
            sfbdhj: '0', //是否报到环节
            sfdybdd: '0', //是否打印报到单
            zt: '1', //是否启用
            editable: true, //编辑模式
        };
        hjxxData.push(newHjxxData);
        this.props.onChange(hjxxData);
        this.setState({ hjxxData: hjxxData });

    }

    render() {

        const columns = [
            {
                title: '步骤',
                key: 'bz',
                dataIndex: 'bz',
                width: '60px'
            }, {
                title: '环节名称',
                key: 'hjmc',
                dataIndex: 'hjmc',
                width: '110px',
                render: (text, record) => {
                    const editable = record.editable;
                    //不能重复选择相同环节
                    const filterKeys = this.state.hjxxData.map((item) => { if (record.pkid != item.pkid) { return item.hjid } });
                    return (
                        editable ?
                            <NHSelect style={{ margin: '-5px 0', width: '100%' }} sign="zhxg_yxxt_lcgl_hjxx"
                                value={record.hjid} filterData={{ type: 'remove', filterkeys: filterKeys }}
                                onSelect={(value, label, option) => {
                                    this.handleEditableCellChange(value, record.pkid, 'hjid');
                                    this.handleEditableCellChange(label, record.pkid, 'hjmc')
                                }} />
                            : text
                    );
                },
            }, {
                title: '必须环节',
                key: 'hjlb',
                dataIndex: 'hjlb',
                width: '80px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Switch style={{ margin: '-5px 0' }} checkedChildren="是" unCheckedChildren="否"
                                checked={text == '1' ? true : false}
                                onChange={value => this.handleEditableCellChange(value ? '1' : '0', record.pkid, 'hjlb')} />
                            : (text == '1' ? <Icon type="check-circle" style={{ fontSize: 16, color: '#53c41a' }} />
                                : <Icon type="close-circle" style={{ fontSize: 16, color: '#ff4d4f' }} />)
                    );
                },
            }, {
                title: '报到环节',
                key: 'sfbdhj',
                dataIndex: 'sfbdhj',
                width: '80px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Switch style={{ margin: '-5px 0' }} checkedChildren="是" unCheckedChildren="否"
                                checked={text == '1' ? true : false}
                                onChange={value => this.handleEditableCellChange(value ? '1' : '0', record.pkid, 'sfbdhj')} />
                            : (text == '1' ? <Icon type="check-circle" style={{ fontSize: 16, color: '#53c41a' }} />
                                : <Icon type="close-circle" style={{ fontSize: 16, color: '#ff4d4f' }} />)
                    );
                },
            }, {
                title: '打印报到单',
                key: 'sfdybdd',
                dataIndex: 'sfdybdd',
                width: '80px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Switch style={{ margin: '-5px 0' }} checkedChildren="允许" unCheckedChildren="禁止"
                                checked={text == '1' ? true : false}
                                onChange={value => this.handleEditableCellChange(value ? '1' : '0', record.pkid, 'sfdybdd')} />
                            : (text == '1' ? <Icon type="check-circle" style={{ fontSize: 16, color: '#53c41a' }} />
                                : <Icon type="close-circle" style={{ fontSize: 16, color: '#ff4d4f' }} />)
                    );
                },
            }, {
                title: '是否启用',
                key: 'zt',
                dataIndex: 'zt',
                width: '60px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Switch style={{ margin: '-5px 0' }} checkedChildren="启用" unCheckedChildren="停用"
                                checked={text == '1' ? true : false}
                                onChange={value => this.handleEditableCellChange(value ? '1' : '0', record.pkid, 'zt')} />
                            : (text == '1' ? <Icon type="check-circle" style={{ fontSize: 16, color: '#53c41a' }} />
                                : <Icon type="close-circle" style={{ fontSize: 16, color: '#ff4d4f' }} />)
                    );
                },
            }, {
                title: '操作',
                key: 'operation',
                dataIndex: 'operation',
                width: '110px',
                render: (text, record) => {
                    const { editable } = record;
                    return (
                        <div className={style["editable-row-operations"]}>
                            {
                                editable ?
                                    <span>
                                        <a style={{ margin: 0 }} onClick={() => this.save(record.pkid)}>保存</a>
                                        <Divider type={'vertical'} />
                                        <a onClick={() => this.cancel(record, record.pkid)}>取消</a>
                                    </span>
                                    : <span>
                                        <a style={{ margin: 0 }} onClick={() => this.edit(record.pkid)}>编辑</a>
                                        <Divider type={'vertical'} />
                                        <a onClick={() => this.delete(record, record.pkid)}>删除</a>
                                    </span>
                            }
                        </div>
                    );
                },
            }
        ];

        return (
            <div>
                <Table dataSource={this.state.hjxxData} columns={columns} pagination={false} />
                <Button style={{ marginTop: '5px', width: '100%' }} type="dashed" icon={'plus'}
                    onClick={this.handleAddLinkBtnClick}>
                    添加环节
                </Button>
            </div>
        )
    }
}

SeconedStep.propTypes = {
    data: PropTypes.array, //缓存数据
    onChange: PropTypes.func //环节配置信息改变时回调
}

export default SeconedStep;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/edit-form/step-second.js